export default function isEmpty(value) {
    return !value
        || value.length < 1
        || (Object.keys(value).length === 0 && value.constructor === Object);
}
